export const generalInformationMock = [
  'Entity rating',
  'Public',
  'Unsolicited',
  'Without entity participation',
];
